import React, { useEffect, useState } from 'react'
import { Box, Button, Grid, Typography, Snackbar } from '@material-ui/core'
import { Alert } from '@material-ui/lab'
import { isEmpty } from 'lodash'

import SteppedContent from '../common/SteppedContent'
import { pushSnowplow, toUserUnboardingProcessSchema } from '../../util/snowplow'
import {
  CLICKED_COMPLETE_ONBOARDING,
  CLICKED_NEXT,
  SELECTED_STORE_TYPE,
  UNSELECTED_STORE_TYPE,
  VIEWED_INFORMATIONAL_SNACKBAR,
} from '../../util/events/onboardingEvents'
import cuisineTypeOptions from '../../util/cuisineTypeOptions'
import { ONBOARDING_STEPS } from './onboardingUtils'

import FormControlItem from './FormControlItem'

const UNCATEGORIZED_OPTION = 24

const StepCuisineTypes = ({
  setCurrentStep,
  updateUserProgressStart,
  showSnackbar,
  hasMobileApp,
  setSuccess,
}) => {
  const [cuisineTypes, setCuisineTypes] = useState([])
  const [validationError, setValidationError] = useState(null)

  useEffect(() => {
    if (showSnackbar) {
      pushSnowplow(
        toUserUnboardingProcessSchema(
          VIEWED_INFORMATIONAL_SNACKBAR,
          ONBOARDING_STEPS.CUISINE_TYPES.name,
        ),
      )
    }
  }, [showSnackbar])

  useEffect(() => {
    if (!isEmpty(cuisineTypes)) setValidationError(null)
  }, [cuisineTypes])

  const handleChange = value => {
    if (cuisineTypes.includes(value)) {
      setCuisineTypes(cuisineTypes.filter(v => v !== value))
      pushSnowplow(
        toUserUnboardingProcessSchema(
          UNSELECTED_STORE_TYPE,
          ONBOARDING_STEPS.CUISINE_TYPES.name,
          value,
        ),
      )
    } else {
      setCuisineTypes([...cuisineTypes, value])
      pushSnowplow(
        toUserUnboardingProcessSchema(
          SELECTED_STORE_TYPE,
          ONBOARDING_STEPS.CUISINE_TYPES.name,
          value,
        ),
      )
    }
  }

  const handleSubmit = () => {
    if (isEmpty(cuisineTypes)) {
      const errorMessage = 'Please select a cuisine type.'
      setValidationError(errorMessage)
      pushSnowplow(
        toUserUnboardingProcessSchema(
          CLICKED_NEXT,
          ONBOARDING_STEPS.CUISINE_TYPES.name,
          null,
          errorMessage,
        ),
      )
      return
    }

    updateUserProgressStart({ storeTypes: cuisineTypes })

    // If user has a mobile app already, we are skipping the last step and finish the process
    if (hasMobileApp) {
      pushSnowplow(
        toUserUnboardingProcessSchema(
          CLICKED_COMPLETE_ONBOARDING,
          ONBOARDING_STEPS.CUISINE_TYPES.name,
        ),
      )
      setSuccess(true)
      return
    }

    pushSnowplow(toUserUnboardingProcessSchema(CLICKED_NEXT, ONBOARDING_STEPS.CUISINE_TYPES.name))
    setCurrentStep(ONBOARDING_STEPS.MOBILE_DOWNLOAD)
  }

  return (
    <SteppedContent
      title="Tell us your favorite cuisine types"
      description="Which types of restaurants do you like best? We'll let you know in advance when they're coming."
      progressText={`Step ${ONBOARDING_STEPS.CUISINE_TYPES.value} of 3`}
      action={
        <>
          <Button variant="contained" color="primary" onClick={handleSubmit}>
            {hasMobileApp ? 'Finish Setup' : 'Next'}
          </Button>
          <Box marginTop={2}>
            <Typography color="error">{validationError}</Typography>
          </Box>
        </>
      }
    >
      <Grid component="fieldset" container spacing={2}>
        {cuisineTypeOptions
          ?.filter(({ value }) => value !== UNCATEGORIZED_OPTION)
          .map(({ label, value }) => (
            <Grid key={value} item xs={4}>
              <FormControlItem
                checked={cuisineTypes.includes(value)}
                onChange={() => handleChange(value)}
                name={`cuisineType${value}`}
                color="primary"
                label={label}
              />
            </Grid>
          ))}
      </Grid>
      <Snackbar open={showSnackbar}>
        <Alert severity="info">
          Your lunch is prepared AND delivered contact-free by the restaurant to ensure quality and
          safety. We don&apos;t use third-party drivers - that means lower fees for you and the
          restaurants!
        </Alert>
      </Snackbar>
    </SteppedContent>
  )
}

export default StepCuisineTypes
